module.exports = __webpack_public_path__ + "assets/img/抖音号.4c9c943e.jpg";